import { EyeInvisibleOutlined, FlagFilled } from '@ant-design/icons'
import { PopoverContent } from '@components/_SiteWide/Flags/PopoverContent'
import { BBDTag, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Popover } from 'antd'
import React, { useState } from 'react'

import { SingleFlag } from '../../../../_SiteWide/Flags/FlagIcon'
import { useSecurityContext } from '../../../../Navigation/SecurityContext'

export function OrderFlagAlert({ flags, order, updateOrder, updateGridOrder, showLabel = true }) {
  const unresolvedFlags = flags.filter((flag) => flag.reason_code === null)
  const resolvedFlags = flags.filter((flag) => flag.reason_code !== null)
  if (unresolvedFlags.length === 0 && resolvedFlags.length === 0) return null
  return (
    <Horizontal className='py-1 px-3' bg='default' gap={24} border={showLabel ? 'all' : undefined} verticalCenter>
      {showLabel && (
        <Horizontal gap={8} verticalCenter>
          <FlagFilled />
          <Texto category='h6' weight='bold'>
            Order Flags:
          </Texto>
        </Horizontal>
      )}
      <Horizontal gap={8} flex={1} verticalCenter>
        {unresolvedFlags.length > 0 &&
          unresolvedFlags.map((f, i) => {
            if (f.type !== 'run_out' && f.type !== 'unset') {
              return (
                <FlagAlert key={i} flag={f} order={order} updateOrder={updateOrder} updateGridOrder={updateGridOrder} />
              )
            }
          })}
      </Horizontal>
      {resolvedFlags.length > 0 && (
        <Horizontal gap={8} verticalCenter>
          <Horizontal gap={4} verticalCenter>
            <EyeInvisibleOutlined />
            <Texto category='h6' className='mr-3' weight='bold' style={{ marginLeft: 5 }}>
              Resolved:
            </Texto>
          </Horizontal>
          {resolvedFlags.map((f, i) => {
            if (f.type !== 'run_out' && f.type !== 'unset') {
              return (
                <FlagAlert key={i} flag={f} order={order} updateOrder={updateOrder} updateGridOrder={updateGridOrder} />
              )
            }
          })}
        </Horizontal>
      )}
    </Horizontal>
  )
}
function FlagAlert({ flag, order, updateOrder, updateGridOrder }) {
  const [isVisible, setIsVisible] = useState(false)

  const { scopes } = useSecurityContext()
  const isCarrier = scopes?.is_carrier
  if (isCarrier) return null
  const popoverContent = (flag) => {
    return (
      <PopoverContent
        key={flag}
        flag={flag}
        orderId={order?.id}
        orderNumber={order?.number}
        setIsVisible={setIsVisible}
        updateOrder={updateOrder}
        updateGridOrder={updateGridOrder}
      />
    )
  }
  const toggleVisibility = (open, buttonClose = false) => {
    if (buttonClose) setIsVisible(false)
    open ? setIsVisible(true) : setIsVisible(false)
  }
  return (
    <BBDTag
      style={{ cursor: 'pointer' }}
      warning={flag.severity === 'warning'}
      error={flag.severity === 'error'}
      success={flag.severity === 'money' && flag.type !== 'dependent'}
    >
      <Popover
        style={{ width: 600 }}
        trigger={['click', 'contextMenu']}
        placement='bottomRight'
        content={popoverContent(flag)}
        onOpenChange={toggleVisibility}
        open={isVisible}
        title={
          <>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Texto> Order Flags </Texto>
              {!!order?.number && <Texto> Order {order?.number} </Texto>}
            </div>
          </>
        }
      >
        <Horizontal gap={8} className='py-1' verticalCenter>
          <SingleFlag flag={flag} isOrderFlag />
          <Texto weight='bold' appearance={flag.severity}>
            {flag.name}
          </Texto>
        </Horizontal>
      </Popover>
    </BBDTag>
  )
}
